//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        name: 'Cpts024',
        props: {
            service: {
                type: String,
                default: ''
            },
            rule: {
                type: Object,
                default: {}
            }
        },
        data () {
            return {
                services: [],
                shutterHandle: false,
                shutter: false
            }
        },
        computed: {
            serviceList: function () {
                if (this.services) {
                    return this.shutter ? this.services.slice(0, 8) : this.services
                }
            },
        },
        methods: {
            init: function () {
                let ruleLength = 0
                const serviceTemp = this.service ? this.service.split(',') : [],
                    services = []
                for (const key in this.rule) {
                    ruleLength++
                    const temp = (serviceTemp.indexOf(key) != -1) ? {name: this.rule[key], exist: true} : {name: this.rule[key], exist: false}
                    services.push(temp)
                }
                if (ruleLength > 8) {
                    this.shutterHandle = true
                    this.shutter = true
                } else {
                    this.shutterHandle = false
                    this.shutter = false
                }
                this.$set(this, 'services', services)
            },
            changeShutter: function () {
                this.shutter = !this.shutter
            }
        }
    }
